export default import.meta.ROLLDOWN_FILE_URL_Fg7czheGUsu8Ypm7sr$dbQ